import type { Catalog } from '..'

export const hosted: Catalog['hosted'] = {
  exportTitle: 'Exportar do Doop',
  exportLede:
    'Escolha para onde vão seus frames. PDF, Photoshop e Canva deixam você escolher os frames em seguida; o Figma leva sua seleção como está.',
  exportPdfSource: 'Documento PDF',
  exportPdfSourceBlurb: 'Uma página vetorial por frame, o texto continua selecionável.',
  psdSource: 'Arquivo do Photoshop',
  exportPsdSourceBlurb: 'Um PSD em camadas por frame, com textos e grupos ainda editáveis.',
  canvaSource: 'Design do Canva',
  exportCanvaSourceConnect: 'Conecte o Canva primeiro. Cada frame vira um design.',
  exportCanvaSourceBlurb: 'Cada frame vira um design do Canva que você pode continuar editando.',
  exportFigmaSource: 'Figma',
  exportFigmaSourceBlurb: 'Textos, formas e imagens editáveis pelo plugin do Doop.',
  exportPsdTitle: 'Exportar como arquivos do Photoshop',
  exportPsdLede: 'Cada frame marcado é baixado como um PSD próprio em camadas, com textos e grupos ainda editáveis.',
  exportPsdNote: 'Um frame carregado pode levar alguns segundos para renderizar.',
  exportPsdAction: 'Baixar PSD',
  exportPsdActionMany: 'Baixar {count} PSDs',
  exportCanvaTitle: 'Exportar para o Canva',
  exportCanvaLede:
    'Cada frame marcado vira um novo design do Canva com caixas de texto editáveis. O Canva renderiza um de cada vez.',
  exportCanvaNote:
    'Cada design abre em uma nova aba quando fica pronto — isso pode levar um ou dois minutos por frame.',
  exportCanvaAction: { one: 'Enviar {count} frame para o Canva', other: 'Enviar {count} frames para o Canva' },
  exportCanvaConnectLede:
    'Cada frame vira um novo design do Canva com caixas de texto editáveis. Conecte sua conta do Canva na página de Integrações primeiro, depois volte e escolha o Canva de novo.',
  exportCanvaConnectNote: 'Conectar leva um minuto e só acontece uma vez.',
  openIntegrations: 'Abrir Integrações',
  integrations: 'Integrações',
  canvasExportTitle: 'Exportar frames para Photoshop, Canva ou Figma',

  frameExportLede: 'Baixe uma imagem ou um arquivo em camadas, ou continue editando no Canva ou no Figma.',
  frameExportLedeFigma: 'Baixe uma imagem ou um arquivo em camadas, ou continue editando no Figma.',
  frameExportPsd: 'Baixar PSD',
  frameExportPsdHint: 'Arquivo do Photoshop em camadas, com textos e grupos editáveis',
  frameExportCanvaConnectBefore: 'Conecte o Canva na aba',
  frameExportCanvaConnectAfter: 'primeiro.',
  sendToFigma: 'Enviar para o Figma…',
  sendFramesToFigma: { one: 'Enviar {count} frame para o Figma…', other: 'Enviar {count} frames para o Figma…' },

  importPsdBlurb: 'Cada camada vira um elemento editável.',
  importCanvaBlurb: 'Cole o link de um design. As páginas viram frames.',
  importDesign: 'Importar design',
  canvaDisconnectCopy: 'Os frames já importados continuam nos seus canvases.',
  figmaDisconnectCopy:
    'Importar do Figma vai pedir para você conectar de novo. Os frames que já estão nos seus canvases continuam.',

  searchFeedback: 'Buscar feedback dos agentes',
}
